import React, { useRef } from "react";

export default function Height({ onChange }) {
    const [displayValue, setDisplayValue] = React.useState("");
    const inputRef = useRef(null);

    const handleChange = (event) => {
        const newDisplayValue = event.target.value;
        const filteredDisplayValue = newDisplayValue
            .replace(/[^0-9,]/g, "")
            .replace(/(,.*),/g, "$1");

        setDisplayValue(filteredDisplayValue);
        onChange(Number(filteredDisplayValue.replace(",", ".")));
    };

    return (
        <div
            className=""
            onClick={() => inputRef.current && inputRef.current.focus()}
        >
            <div
                className="text-sm sm:text-base mb-2 cursor-default"
                id="HeightLabel"
            >
                Votre taille
            </div>
            <div className="flex items-center gap-2">
                <input
                    ref={inputRef}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="py-2 w-16 sm:w-24 text-center px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300 focus:border-slate-500"
                    onChange={handleChange}
                    value={displayValue}
                    aria-labelledby="HeightLabel"
                    aria-describedby="HeightDescription"
                    role="spinbutton"
                    aria-valuenow={displayValue}
                />
                <div className="text-base sm:text-xl font-bold cursor-default">cm</div>
                <div id="HeightDescription" className="hidden">
                    Entrez votre taille en centimetres. Utilisez une virgule pour les
                    décimales.
                </div>
            </div>
        </div>
    );
}
